import { gql } from '@apollo/client';

export const CreateBuyDirectListingOffer = gql`
  mutation CreateBuyDirectListingOffer(
    $buyer: OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput!
    $coBuyer: OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput
    $downPaymentCents: Float
    $financingType: OdProtosWebData_ListingOfferDetails_FinancingStatus
    $closeOfEscrow: OdProtosCommon_DateInput
    $preApprovalLetter: OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_DocumentInput
    $listing: OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_ListingOneofInput
  ) {
    webBuyDirectListingOffer {
      createBuyDirectOffer(
        input: {
          buyer: $buyer
          coBuyer: $coBuyer
          downPaymentCents: $downPaymentCents
          financingType: $financingType
          closeOfEscrow: $closeOfEscrow
          preApprovalLetter: $preApprovalLetter
          listing: $listing
        }
      ) {
        listingOfferId
        contractSignatureId
      }
    }
  }
`;
